import React from 'react';
import styles from './index.module.scss';
import RenderInfo from '../../../components/RenderInfo/index';

const UserDetails = (props) => {
  const { userDetails: { objectId = '', full_name: fullName='', email = '' } = {}} = props;

  return <div className={styles['shopping-list-details-section']}>
    <div className={styles['shopping-list-info']}>
      <div className={styles['info']}>
        <RenderInfo heading="User Id" value={objectId} link={`/users/${objectId}`} />
        <RenderInfo heading="Email" value={email} />
      </div>
      <div className={styles['info']}>
        <RenderInfo heading="Name" value={fullName} />
      </div>
    </div>
  </div>;
};

export default UserDetails;